/* @ngInject */
function ShowMoreArtsButtonController ($scope) {
  const api = {
  }

  this.getApi = () => api

  activate()
  function activate () {
  }
}

export { ShowMoreArtsButtonController }
